import { render, staticRenderFns } from "./exhibition-template-factory.vue?vue&type=template&id=2f43a47b&scoped=true&"
import script from "./exhibition-template-factory.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-factory.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-factory.vue?vue&type=style&index=0&id=2f43a47b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f43a47b",
  null
  
)

export default component.exports